export const getSampleMessagesMinAndContentAttributes = ({ mno_metadata: mnoMetaData = {}, usecase } = {}) => {
  let sampleMessagesMin = 1;
  let contentAttributesRequired = {};
  let qualified = false;
  const items = Object.values(mnoMetaData);
  items.forEach(item => {
    sampleMessagesMin = item.min_msg_samples < sampleMessagesMin ? sampleMessagesMin : item.min_msg_samples;
    qualified += item.qualify;
    contentAttributesRequired = {
      subscriberOptIn: true,
      subscriberOptOut: usecase !== '2FA',
      subscriberHelp: true,
      directLending: false,
      ageGated: false,
      numberPool: false,
      embeddedPhone: false,
      embeddedLink: false,
      affiliateMarketing: false,
    };
  });
  return { sampleMessagesMin, contentAttributesRequired, qualified };
};
